import { useEffect } from 'react';
import WhoDunIt2026 from '../../classes/WhoDunIt2026';
import './Whodunit2026Page.css';

const Whodunit2026Page = ({ action = 'enable' }) => {
  useEffect(() => {
    if (action === 'exit') {
      WhoDunIt2026.exit();
    } else {
      WhoDunIt2026.enable();
      if (action === 'reset') {
        WhoDunIt2026.resetProgress();
      }
    }

    window.location.replace('/');
  }, [action]);

  return null;
};

export default Whodunit2026Page;
